module.exports = __webpack_public_path__ + "img/icon_wait_white.9a38c03f.svg";